import WorkflowStepValidation from "./workflowStepValidation";
import WorkflowStepLinkedDocumentValidator from "../navigableValidators/workflowStepLinkedDocumentValidator";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import ProcessFlowWorkflowStep from "../../../formability/form_builder/models/workflow/processFlowWorkflowStep";
import FieldPresenceValidator from "~/models/navigableValidators/fieldPresenceValidator";
import Selected from "~/../formability/form_builder/store/modules/selected"
import {IErrorNavOpts} from "~/models/validationError";

export default class ProcessFlowWorkflowStepValidation extends WorkflowStepValidation<ProcessFlowWorkflowStep> {
  validators = new WorkflowStepValidation(this.model).validators.concat([
    new WorkflowStepLinkedDocumentValidator({
      validatorKey: "process_flow",
      section: ValidationModalSection.Workflow,
      anchorHash: 'process-flow-search'
    }),
    new FieldPresenceValidator({
      validatorKey: 'form_submission_variable_reference_id',
      section: ValidationModalSection.Workflow,
      conditional: (model: ProcessFlowWorkflowStep, validatorKey) => {
        return !!model.process_flow_id && model.process_flow.variables.filter(v => !!v.is_input).length > 0
      },
      beforeReveal: async () => {
        Selected.workflowStep.set(this.model);
        await window.requestAnimationFrame(async () => {
          await $("#configure-process-flow").trigger("click");
        })
      },
      displayName: "Form Submission Variable Selection",
    }),

  ]);

  errorNavOpts(validator, field: string, value?): IErrorNavOpts {
    let base = super.errorNavOpts(validator, field, value)
    Object.assign(base, {
      targetElementId: this.model.idForProp(field),
    });
    return base;
  }

}